import { Avatar } from "@/elements"

const GridVersion = () => {
  return (
    <div className="flex w-full flex-col gap-y-5 rounded-xl border border-bg-3 p-6">
      <div className="flex flex-row items-center justify-between">
        <div className="flex flex-row items-center">
          <div className="mr-4">
            <Avatar size="xl" />
          </div>
          <div className="flex flex-col items-start gap-y-[6px]">
            <div className="h-4 w-28 animate-pulse rounded-sm bg-bg-2" />
            <div className="h-[15px] w-[87px] animate-pulse rounded-sm bg-bg-2" />
          </div>
        </div>
        <div className="flex flex-col items-end gap-y-3">
          <div className="h-[14px] w-24 animate-pulse rounded-sm bg-bg-2" />
          <div className="flex flex-row items-center gap-x-1">
            <div className="ml-1 h-[14px] w-20 animate-pulse rounded-sm bg-bg-2" />
          </div>
        </div>
      </div>
      <div className="h-[180px] w-full animate-pulse rounded-md bg-bg-2" />
    </div>
  )
}

const ListVersion = () => {
  return (
    <div className="flex w-full flex-col">
      <div className="flex flex-row justify-between">
        <div className="flex flex-row items-center">
          <Avatar size="xl" />
          <div className="ml-4 flex flex-col justify-center gap-2">
            <div className="h-6 w-28 animate-pulse rounded-sm bg-bg-2" />
            <div className="h-[15px] w-36 animate-pulse rounded-sm bg-bg-2" />
          </div>
        </div>
        <div className="flex flex-row items-center justify-between">
          <div className="flex flex-col items-start gap-y-[6px]">
            <div className="flex flex-row items-center gap-x-6">
              <div className="h-[14px] w-24 animate-pulse rounded-sm bg-bg-2" />
              <div className="flex flex-row items-center gap-x-1">
                <div className="ml-1 h-[14px] w-20 animate-pulse rounded-sm bg-bg-2" />
              </div>
              <div className="ml-12 flex flex-row gap-2">
                <div className="h-[50px] w-[118px] animate-pulse rounded-full bg-bg-2" />
                <div className="h-[50px] w-[118px] animate-pulse rounded-full bg-bg-2" />
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="mt-6 h-[214px] w-full animate-pulse rounded-md bg-bg-2" />
    </div>
  )
}

export const BusinessCardSkeleton: React.FC<{ type: "list" | "grid" }> = ({ type }) => {
  if (type === "list") {
    return (
      <>
        <div className="hidden w-full md:flex">
          <ListVersion />
        </div>
        <div className="md:hidden">
          <GridVersion />
        </div>
      </>
    )
  }

  // Grid version
  return <GridVersion />
}
